import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";

type Interest = {
        id: number;
        financeAmount: number;
        months: number;
        apr: number;
      }[]

    type ClientDetails = {
        "nombreCompleto": string,
        "numeroProductor": string,
        "email": string,
        "celular": string,
        "otroTelefono": string,
        "direccion1": string,
        "direccion2": string,
        "ciudad": string,
        "estado": string,
        "codigoPostal": string,
        "efectividad"?: string
    }

let apiUrl =
  typeof window !== "undefined" && window.location.href.includes("localhost")
    ? "/api/"
    // : "https://api.ccc-pr.com/api/";
    : "https://api.prcstest.net/api/";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  httpOptions: { headers: HttpHeaders };
  authenticationState = new BehaviorSubject(false);

  constructor(private http: HttpClient, private router: Router) {
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Basic " + localStorage.getItem("IdToken"),
      }),
    };
  }

  signIn(data: any) {
    console.log(data);
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "loginproducer", data, this.httpOptions)
        .subscribe(
          (res: any) => {
            if (res) {
              localStorage.setItem("login", "true");
              if (res.errorMessage) {
                reject(res);
              } else {
                if (res.Active == "False") {
                  reject("Cuenta desactivada");
                } else {
                  if (res) {
                    // res.selectedService = selectedService;
                    this.saveCredentials(res);
                  }
                  resolve(res);
                }
              }
            }
            resolve(res);
          },
          (err) => {
            console.log(err);
            reject(err);
          }
        );
    });
  }

  // New Functions
  getProducers() {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + "getproducers", this.httpOptions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getParameters() {
    const token = localStorage.getItem("IdToken");
    return new Promise((resolve, reject) => {
      this.httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: "Basic " + token,
        }),
      };
      this.http.get(apiUrl + "getparameters", this.httpOptions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  updateSelectedService(selectedService: any) {
    localStorage.setItem("selectedService", selectedService);
  }

  saveCredentials(data: any) {
    localStorage.setItem("IdToken", data.token);
    localStorage.setItem("userFullName", data.complete_name);
    localStorage.setItem("producerId", data.producer_id);
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Basic " + data.token,
      }),
    };
  }

  saveFinanceData(financeData: any) {
    let data: any = localStorage.getItem("financeData");
    if (data) {
      data = JSON.parse(data);
      let fData = data.filter((x: any) => x.id == financeData.id);
      if (fData.length > 0) {
        let index = data.findIndex((obj: any) => {
          return obj.id == financeData.id;
        });
        data = data.splice(index, 1);
        data.push(financeData);
      } else {
        data.push(financeData);
      }
    } else {
      data = [];
      data.push(financeData);
    }
    data = JSON.stringify(data);

    localStorage.setItem("financeData", data);
    console.log(data);
  }

  getFinaceData(contractId: any) {
    let data: any = localStorage.getItem("financeData");

    if (data) {
      data = JSON.parse(data);
      let financeData = data.filter((x: any) => x.id == contractId);
      if (financeData.length > 0) {
        return financeData[0].data;
      }
    }
  }

  removeFinaceData(contractId: any) {
    let data: any = localStorage.getItem("financeData");

    if (data) {
      data = JSON.parse(data);
      let index = data.findIndex((obj: any) => {
        return obj.id == contractId;
      });
      console.log(index);
      console.log(data);
      data = data.splice(index + 1, 1);
      console.log(data);
      data = JSON.stringify(data);
      console.log(data);
      localStorage.setItem("financeData", data);
    }
  }

  getUserFullName() {
    return localStorage.getItem("userFullName");
  }
  getUserRole() {
    return localStorage.getItem("userRole");
  }

  getSelectedService() {
    return localStorage.getItem("selectedService");
  }

  getUserId() {
    return localStorage.getItem("producerId");
  }
  getUserTel() {
    return localStorage.getItem("userTel");
  }
  getSucAgency() {
    return localStorage.getItem("suc_agency")
  }

  getSegComp(policyType: any) {
    // console.log(policyType);
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "getsegcomp", policyType, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  checkToken() {
    let login = localStorage.getItem("login");
    console.log(login);
    if (login == "true") {
      this.authenticationState.next(true);
      // this.router.navigateByUrl('/dashboard');
    }
    //
    // this.authenticationState.next(true);
    // this.getCompanies().then(res => {
    // console.log(res);
    // this.authenticationState.next(true);
    // }, err => {
    //   console.log(err);
    //   let refreshToken = localStorage.getItem("RefreshToken");
    //   let selectedService = localStorage.getItem("selectedService");
    //   // console.log(refreshToken);
    //   if(refreshToken){
    //     let data = {RefreshToken: refreshToken}
    //     this.signIn(data, selectedService).then((res:any)=>{
    //         this.saveCredentials(res);
    //     })
    //   }
    // });
  }

  forgotPassword(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl + "forgotpwd", data, this.httpOptions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  confirmPassword(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl + "confirmpwd", data, this.httpOptions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  setNewPassword(data: any) {
    // console.log(data);
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl + "setnewpwd", data, this.httpOptions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getInterest(interestType: any) {
    // console.log(interestType);
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "getinterest", interestType, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  // getCompanies() {
  //   return new Promise((resolve, reject) => {
  //     this.http.get(apiUrl + "companies",  this.httpOptions)
  //       .subscribe(
  //         res => {
  //           resolve(res);
  //         },
  //         err => {
  //           reject(err);
  //         }
  //       );
  //   });
  // }

  getAgencies() {
    return new Promise((resolve, reject) => {
      this.httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        }),
      };
      this.http.get(apiUrl + "getagencies", this.httpOptions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getCompanies() {
    return new Promise((resolve, reject) => {
      this.httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        }),
      };
      this.http.get(apiUrl + "getcompanies", this.httpOptions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getPartnerFromPolicy(policy: string) {
    return new Promise((resolve, reject) => {
      this.httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        }),
      };
      this.http
        .get(
          apiUrl + "getPartnerFromPolicy/?policy=" + policy,
          this.httpOptions
        )
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  postFullContract(data: { data: any; id?: number }) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          apiUrl + "postFullContract" + (data.id ? "/" + data.id : ""),
          data.data,
          this.httpOptions
        )
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getCompanyDetails(id: any) {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + "companies/" + id, this.httpOptions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getContractDetails(id: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "getcontractdetails/", { id }, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getBranches(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "branchesbycompany", data, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  addCompany(data: object) {
    // console.log(data);
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "companies", JSON.stringify(data), this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  removeCompany(companyId: any) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(apiUrl + "companies/" + companyId, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  editCompany(data: any) {
    // console.log(data);
    return new Promise((resolve, reject) => {
      this.http
        .put(
          apiUrl + "companies/" + data.id,
          JSON.stringify(data),
          this.httpOptions
        )
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  addBranch(data: any) {
    // console.log(data);
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "branches", JSON.stringify(data), this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  removeBranch(branchId: any) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(apiUrl + "branches/" + branchId, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  editBranch(data: any) {
    // console.log(data);
    return new Promise((resolve, reject) => {
      this.http
        .put(
          apiUrl + "branches/" + data.id,
          JSON.stringify(data),
          this.httpOptions
        )
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getUsers() {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + "users", this.httpOptions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  addUser(data: object) {
    console.log(data);
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "createuser", JSON.stringify(data), this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
            console.log(res);
          },
          (err) => {
            console.log(err);
            reject(err);
          }
        );
    });
  }

  editUser(data: any) {
    // console.log(data);
    return new Promise((resolve, reject) => {
      this.http
        .put(
          apiUrl + "users/" + data.id,
          JSON.stringify(data),
          this.httpOptions
        )
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  createInstallments(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "createcontractinstallments", data, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
            // console.log(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  installementsByDate(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "installmentsbydate", data, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
            // console.log(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  editInstallment(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .put(apiUrl + "contractinstallments/" + data.id, data, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
            // console.log(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  deleteInstallments(id: any) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(apiUrl + "contractinstallments/" + id, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
            // console.log(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  deleteContract(id: any) {
    return new Promise((resolve, reject) => {
      this.http.delete(apiUrl + "contracts/" + id, this.httpOptions).subscribe(
        (res) => {
          resolve(res);
          // console.log(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getAllContracts(data: any) {
    let obj = {
      Id: data,
    };

    this.updateHttpOptions();

    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "getprodcontracts", obj, this.httpOptions)
        .subscribe(
          (res) => resolve(res),
          (err) => reject(err)
        );
    });
  }

  uploadContract(data: any ) {
    this.updateHttpOptions();

    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "uploadcontract", data, {})
        .subscribe(
          (res) => resolve(res),
          (err) => reject(err)
        );
    });
  }

  getContract2() {
    return localStorage.getItem("contractData");
  }

  getContract(id: any) {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + "contracts/" + id, this.httpOptions).subscribe(
        (res) => {
          resolve(res);
          // console.log(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  createContract(data: any) {
    localStorage.setItem("contractData", JSON.stringify(data));
    // return new Promise((resolve, reject) => {
    //   this.http.post(apiUrl + "contracts", data, this.httpOptions)
    //     .subscribe(
    //       res => {
    //         resolve(res);
    //         // console.log(res);
    //       },
    //       err => {
    //         reject(err);
    //       }
    //     );
    // });
  }

  createLoanContract(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl + "loans", data, this.httpOptions).subscribe(
        (res) => {
          resolve(res);
          // console.log(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getLoanContracts() {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + "loans", this.httpOptions).subscribe(
        (res) => {
          resolve(res);
          // console.log(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getPolicySufix() {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + "GetPrefix", this.httpOptions).subscribe(
        (res) => {
          resolve(res);
          // console.log(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getLoanContract(id: any) {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + "loans/" + id, this.httpOptions).subscribe(
        (res) => {
          resolve(res);
          // console.log(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getClientDetailsFromPolicyID(policyId: any): Promise<ClientDetails> {
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl + "validateClient/", {
        "Llave": policyId
      }, this.httpOptions).subscribe(
        (res) => {
          resolve(res as ClientDetails);
          // console.log(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  updateLoanContract(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .put(apiUrl + "loans/" + data.id, data, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
            // console.log(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  deleteLoanContract(id: any) {
    return new Promise((resolve, reject) => {
      this.http.delete(apiUrl + "loans/" + id, this.httpOptions).subscribe(
        (res) => {
          resolve(res);
          // console.log(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  dataStore(data: any) {
    localStorage.setItem("DataStore", data);
  }
  getDataStore() {
    return localStorage.getItem("DataStore");
  }

  emptyDataStore() {
    localStorage.removeItem("DataStore");
  }

  loanDataStore(data: any) {
    localStorage.setItem("LoanDataStore", data);
  }

  getLoanDataStore() {
    return localStorage.getItem("LoanDataStore");
  }

  emptyLoanDataStore() {
    localStorage.removeItem("LoanDataStore");
  }

  loanDataStore2(data: any) {
    localStorage.setItem("LoanDataStore2", data);
  }

  getLoanDataStore2() {
    return localStorage.getItem("LoanDataStore2");
  }

  emptyLoanDataStore2() {
    localStorage.removeItem("LoanDataStore2");
  }

  updateContract(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .put(apiUrl + "contracts/" + data.id, data, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
            // console.log(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  logout() {
    localStorage.removeItem("login");
    localStorage.removeItem("AccessToken");
    localStorage.removeItem("IdToken");
    localStorage.removeItem("RefreshToken");
    localStorage.removeItem("userFullName");
    localStorage.removeItem("DataStore");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userId");
    localStorage.removeItem("userTel");
    if (this.authenticationState.value) {
      this.authenticationState.next(false);
      this.router.navigate(["/login"]);
    }
  }

  getAuthStatus() {
    return this.authenticationState.value;
  }

  //metodos nuevos

  getAmortization(data: any) {
    return new Promise((resolve, reject) => {
      // let obj = {
      //   ...this.httpOptions,
      //   params: {}
      // }
      // let params = new HttpParams()
      // .set("loanDate",data.loanDate)
      // .set("loanAmount",data.loanAmount)
      // .set("interestRate", data.interestRate)
      // .set("terms", data.terms);

      // obj.params = params;

      // console.log(obj);

      this.http
        .post(apiUrl + "qamortization", data, this.httpOptions)
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  startLoan(data: any) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "X-Api-Key": "e0a95c0a-f7eb-4dad-9a91-39a311c7327d",
      }),
    };
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl + "akloan", data, httpOptions).subscribe(
        (res) => {
          resolve(res);
          // console.log(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getaprlessthan20(data: { finance_amount: number }): 
    Promise<
      Interest[]
    >
   {
    this.updateHttpOptions();
    return new Promise((resolve, reject) => {
      this.http
        .post(apiUrl + "getaprlessthan", data, this.httpOptions)
        .subscribe(
          (res) => resolve(res as Interest[]),
          (err) => reject(err)
        );
    });
  }

  updateHttpOptions() {
    const expectedAuthHeader = "Basic " + localStorage.getItem("IdToken");
    const actualAuthHeader = this.httpOptions?.headers.get("Authorization");

    if (actualAuthHeader !== expectedAuthHeader) {
      console.warn("Authorization header mismatch or missing!", {
        expected: expectedAuthHeader,
        actual: actualAuthHeader,
      });
      this.httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: "Basic " + localStorage.getItem("IdToken"),
        }),
      };
    } else console.log("Authorization header is set correctly.");
  }

  fetchDirections(data: {
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip1: string;
    zip2: string;
  }) {
    const addressXml = `<AddressValidateRequest USERID="5651WWDIGF061">
  <Address ID="0">
    <Address1>${data.address1}</Address1>
    <Address2>${data.address2}</Address2>
    <City>${data.city}</City>
    <State>${data.state}</State>
    <Zip5>${data.zip1}</Zip5>
    <Zip4>${data.zip2}</Zip4>
  </Address>
</AddressValidateRequest>`;
    // console.log(data);
    return new Promise((resolve, reject) => {
      this.http
        .get(
          "https://secure.shippingapis.com/ShippingAPI.dll?API=Verify&XML=" +
            encodeURIComponent(addressXml),
          { responseType: "text" }
        )
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
}
